// extracted by mini-css-extract-plugin
export default {"backdrop":"ModalTransparent_backdrop__1mwwb","modal":"ModalTransparent_modal__IPg31"};